export default "__VITE_ASSET__DUAbsIv2__"